import i18next from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { getResourcePath } from "web_myplann/Infrastructure/Translations/Resources";

export const translateToCzech = (
	resourcePath: ObjPathProxy<MyPlannResourceDictionary, string>,
) => i18next.getFixedT("cs")(getResourcePath(resourcePath));
